import logo from "./logo.svg";
import "./css/App.css";
import "./css/ReportPage.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import Navbar from "./components/menu/Navbar.js";
import ReportPage from "./components/menu/ReportPage";

import React, { useState, useEffect, useRef } from "react";
//import {useNavigate} from 'react-router-dom';

import { Modal } from "bootstrap";

// import { reactLocalStorage } from "reactjs-localstorage";
import { Button, Accordion } from "react-bootstrap";
import useCustom from "./components/customHook/customHook";

export default function App() {
    
  // Redirect http to https
  if (window.location.hostname != "localhost") {
    if (window.location.protocol !== "https:") {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length
        )}`
      );
    }
  }

  return (
    <>
      {/* <section>
        <Navbar />
      </section> */}
      <section>
        <div className="bg-light pb-4">
          <ReportPage />
        </div>
      </section>
    </>
  );
}
